import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, Inject } from '@angular/core';

@Component({
standalone: false,
  selector: 'app-delete-liability-delegation-confirmation-dialog',
  templateUrl: './delete-liability-delegation-confirmation-dialog.component.html',
  styleUrls: ['./delete-liability-delegation-confirmation-dialog.component.scss'],
})
export class DeleteLiabilityDelegationConfirmationDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}
}
